export const load = () => ({
	title: 'Soundproof Window Solutions',
	h1: 'Reduce Noise In Your Home with Window Inserts',
	description:
		'Soundproof your windows to make your home more peaceful and more comfortable. Indow inserts create a tight seal and additional air space between the insert and the window to help reduce noise.',
	showTitle: true,
});
